module.exports = __webpack_public_path__ + "webcast-14f96098d4ffc3efea7819d30929b620.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/file-formats/webcast.svg
// module id = 47
// module chunks = 0